var Writaholics = Writaholics || {};

Writaholics.Timeline = function () {

	var _init = function () {
		$('.timeline-step.active').popover('show');
		$(function () {
			// get all steps
			var steps = $('.steps').find('.step');
			// hide all steps
			steps.hide();
			// show the active one
			steps.filter('.active').show();
			var timelineStep = $('.timeline-step');
			timelineStep.on('click', function () {
				$('.timeline-step').popover('hide');
				// cache the clicked timeline step
				var timelineStepCache = $(this);
				timelineStepCache.popover('show');
				// get the index value of the clicked one
				var index = timelineStepCache.index();
				// get the step which is matched the index value
				var matchedStep = steps.eq(index);
				// with cached timeline step adding the matched one visible
				timelineStepCache.add(matchedStep).addClass('active').slideDown();
				// hide all timeline steps but not the clicked one and also hide all steps but not the matched one
				timelineStep.not(timelineStepCache).add(steps.not(matchedStep).slideUp()).removeClass('active');
			});
		});
	}

	/** PUBLIC API **/
	return {
		init: function () { return _init(); }
	};

}();

jQuery(function () {
	Writaholics.Timeline.init();
});
